/* src/constants/payments.js */
export const DEPOSIT_LIMITS = {
  currencyLabel: 'KES',
  min: 10,
  maxPerTxn: 70_000,
  maxDaily: 70_000,
};

export const DEPOSIT_PRESETS = [20, 50, 100, 200, 500];

// STK balance polling config (VueUse-driven)
export const DEPOSIT_POLLING = {
  intervalMs: 4000,  // poll every 4s
  maxAttempts: 45,   // ~3 minutes total
};
